export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const KEY = '0db52852-970e-4811-a7c1-8d45b450c1b6';
export const TOTAL_PAGE_DATA = 10;
